import apiClient from './apiClient';

export const spatialApi = {
  searchProjections: async (query) => {
    const response = await apiClient.get('/spatial/projections/search', {
      params: { q: query }
    });
    return response.data;
  },

  validateProjection: async (srid) => {
    const response = await apiClient.get(`/spatial/projections/validate/${srid}`);
    return response.data;
  }
};
